jQuery(document).ready(function($){
  const swiperReview = new Swiper('.block-reviews', {
    slidesPerView: 'auto',
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  const swiperColections = new Swiper('.collection-lists', {
    slidesPerView: 'auto',
    loop: false,
    spaceBetween: 10,
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
    },
    navigation: {
        nextEl: '.collection-lists .swiper-button-next',
        prevEl: '.collection-lists .swiper-button-prev',
    },
    breakpoints: {
    750: {
        spaceBetween: 30,
    },
},
  });

  const swiperFeatured = new Swiper('.featured-cate-wrapper', {
    slidesPerView: 'auto',
    loop: false,
    spaceBetween: 10,
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
    },
    navigation: {
        nextEl: '.featured-cate-wrapper .swiper-button-next',
        prevEl: '.featured-cate-wrapper .swiper-button-prev',
    },
    breakpoints: {
    750: {
        spaceBetween: 30,
    },
},
  });
  
})